import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './faq.module.css';

const FlatRateBoxTable = () => {
  return (
    <div>
      <p>
        {/* <FormattedMessage id="faq.flatRateBoxTable.title" /> */}
        <FormattedMessage id="faq.flatRateBoxTable.titleNew" />
      </p>
      <p>
        {/* <FormattedMessage id="faq.flatRateBoxTable.titleMeasure" /> */}
        <FormattedMessage id="faq.flatRateBoxTable.titleMeasureNew" />
      </p>
      {/* <p> */}
      {/* <ul className={css.bulletList}> */}
      <ol className={css.orderedList}>
        <li>
          {/* <FormattedMessage id="faq.flatRateBoxTable.titleMeasure1"  /> */}
          <FormattedMessage id="faq.flatRateBoxTable.titleMeasure1New"  />
          {/* </p> */}
        </li>
        <li>
     {/* <p> */}
          {/* <FormattedMessage id="faq.flatRateBoxTable.titleMeasure2" /> */}
          <FormattedMessage id="faq.flatRateBoxTable.titleMeasure2New" />
          {/* </p> */}
        </li>
      
      {/* </ul> */}
      </ol>

      <p>
        {/* <FormattedMessage id="faq.flatRateBoxTable.titleCalculator" /> */}
        <FormattedMessage id="faq.flatRateBoxTable.titleCalculatorNew" />
      </p>
      
      {/* <ul className={css.bulletList}>
        <li>
          <FormattedMessage id="faq.flatRateBoxTable.Calculator1"  />
        </li>
        <li>
          <FormattedMessage id="faq.flatRateBoxTable.Calculator2" />
        </li>
        <li>
          <FormattedMessage id="faq.flatRateBoxTable.Calculator3" />
        </li>
      
      </ul> */}
      {/* <p>
        <FormattedMessage id="faq.flatRateBoxTable.noAdditionalFeatures" />
      </p>
      <p>
        <FormattedMessage id="faq.flatRateBoxTable.determineDeliveryStandard" />
      </p> */}

      {/* <table border="1" cellPadding="10" cellSpacing="0">
        <thead>
          <tr>
            <th>
              <FormattedMessage id="faq.flatRateBoxTable.boxSizesAndCosts" />
            </th>
            <th>
              <FormattedMessage id="faq.flatRateBoxTable.extraSmall" />
            </th>
            <th>
              <FormattedMessage id="faq.flatRateBoxTable.small" />
            </th>
            <th>
              <FormattedMessage id="faq.flatRateBoxTable.medium" />
            </th>
            <th>
              <FormattedMessage id="faq.flatRateBoxTable.large" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dimensions" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.extraSmallDimensions" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.smallDimensions" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.mediumDimensions" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.largeDimensions" />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.maxWeight" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.maxWeightValue" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.maxWeightValue" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.maxWeightValue" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.maxWeightValue" />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.price" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.extraSmallPrice" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.smallPrice" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.mediumPrice" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.largePrice" />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dropOffLocation" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dropOffLocationValue1" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dropOffLocationValue1" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dropOffLocationValue2" />
            </td>
            <td>
              <FormattedMessage id="faq.flatRateBoxTable.dropOffLocationValue2" />
            </td>
          </tr>
        </tbody>
      </table> */}
{/* 
      <p>
        <FormattedMessage id="faq.flatRateBoxTable.trackingInfo" />
      </p>
      <a href="https://www.canadapost-postescanada.ca/cpc/en/personal/sending/parcels/flat-rate-box.page">
        <FormattedMessage id="faq.flatRateBoxTable.linkText" />
      </a> */}
    </div>
  );
};

export default FlatRateBoxTable;
